<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import type { SbColor } from '../types';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import Blok from '../blok.svelte';
	import { isEmpty } from '$lib/utils/storyblok/richtext';
	import SbRichtext from '../components/sbRichtext.svelte';

	interface Props {
		content: ISbStoryData<{
			headline?: ISbRichtext;
			subheadline?: ISbRichtext;
			bg_color: SbColor;
			asset: ISbStoryData['content'][];
			facts: ISbStoryData['content'][];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div class="bg-{content.bg_color || 'stone-5'} py-8 lg:py-17" use:editable={content}>
	{#if content.headline && !isEmpty(content.headline)}
		<PageGrid16 margin class="mb-5 text-center">
			<div class="col-span-full lg:col-start-4 lg:col-end-[14]">
				<div
					class="text-pretty text-[44px]/[108%] tracking-[-.44px] text-brown-1 lg:text-[64px]/[104%] lg:tracking-[-.64px]"
				>
					<SbRichtext text={content.headline} />
				</div>
			</div>

			{#if content.subheadline && !isEmpty(content.subheadline)}
				<div
					class="col-span-full mt-3 text-pretty text-[16px]/[150%] tracking-[-.16px] text-brown-4 lg:col-start-5 lg:col-end-[13] lg:mt-5 lg:text-[20px]/[140%] lg:tracking-[-.2px]"
				>
					<SbRichtext text={content.subheadline} />
				</div>
			{/if}
		</PageGrid16>
	{/if}

	<PageGrid16 gridClass="grid-flow-dense">
		<div
			class="col-span-full max-lg:mb-10 max-lg:mt-4 max-lg:flex max-lg:justify-center lg:col-start-10 lg:col-end-[15]"
		>
			<div class="flex h-full flex-col justify-center gap-y-[13px] lg:gap-y-5">
				{#each content.facts as fact}
					<Blok content={fact} />
				{/each}
			</div>
		</div>
		<div class="col-span-full aspect-square lg:col-start-3 lg:col-end-10">
			{#each content.asset as asset}
				<Blok content={asset} />
			{/each}
		</div>
	</PageGrid16>
</div>
